import React, { useEffect, useState } from 'react';
import ArrowIcon from '@mui/icons-material/ExpandLessOutlined';
import { useUiTheme } from 'framework/uiTheme';
import { Box } from '@mui/material';
import classnames from 'classnames';

const ScrollToTop = () => {
  const [isShown, setIsShown] = useState(false);
  const { Button } = useUiTheme();

  const scrollHandler = () => {
    const scrollPosition: number = window.pageYOffset;
    const windowHeight: number = window.innerHeight;
    const shouldDisplayToTopButton = scrollPosition > windowHeight * 1.2;

    setIsShown(shouldDisplayToTopButton);
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);

    return () => window.removeEventListener('scroll', scrollHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Box
      className={classnames('to-top-btn', { 'to-top-btn--hidden': !isShown })}
      sx={{
        display: isShown ? 'block' : 'none',
        opacity: isShown ? 1 : 0,
        position: 'fixed',
        bottom: '57px',
        right: '40px',
        zIndex: 11,
      }}
    >
      <Button
        aria-label="Scroll to top"
        type="button"
        color="primary"
        size="small"
        onClick={scrollToTop}
        sx={{ minWidth: 0, padding: '5px', '&:not(:hover)': { backgroundColor: 'primary.main' } }}
      >
        <ArrowIcon />
      </Button>
    </Box>
  );
};

export default ScrollToTop;
